module.exports = __webpack_public_path__ + "img/gc.a8a36859.png";